const path = 'ListModule';
const ListActions = {
  // action types
  GET_LIST_BY_NAME : `${path}/getListByName`,
  
}

export { ListActions };
